export const Constant = {
  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,
  INITIAL_POSITION_Y: 0,
  FINAL_POSITION_Y: -200,
};
